export default __webpack_public_path__ + "static/media/1028.d4277c49.png";